import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule, Routes } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import {
	ReportDescriptionModalComponent
} from 'src/app/reports/modals/report-description/report-description-modal.component';

import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { UtilService } from 'src/app/shared/services/util.service';
import { FiltersModalModule } from '../shared/modals/filters/filters.module';
import { ImportEmployeeNumber } from './import-employee-number/import-employee-number.component';
import { ReportsPage } from './reports.page';
import { ReportsService } from './reports.service';
import { GroupedAttributesListModule } from 'src/app/shared/components/grouped-attributes-list/grouped-attributes-list.module';
import { JobFollowUpModule } from '../shared/modals/job-follow-up/job-follow-up.module';
import { SelectCycleModule } from '../shared/modals/select-cycle/select-cycle.module';

const routes: Routes = [{
	path: '',
	component: ReportsPage
}];

@NgModule({ imports: [
        CommonModule,
        FormsModule, IonicModule,
        RouterModule.forChild(routes),
        PipesModule,
        HttpClientModule,
        FiltersModalModule,
        GroupedAttributesListModule,
        JobFollowUpModule,
        SelectCycleModule,
        ReactiveFormsModule,
    ],
    declarations: [
        ReportsPage,
        ReportDescriptionModalComponent,
        ImportEmployeeNumber,
    ],
    providers: [
        ReportsService,
        UtilService
    ] })
export class ReportsModule {
}
